module.exports = __webpack_public_path__ + "static/media/topbanner.cd6a2e4c.png";